import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
	downloadClaimsThunk,
	getClaimsByProviderThunk,
	getClaimsNotificationsStatusesThunk,
	getClaimsNotificationsThunk,
} from './claimsThunk';

import { IState } from 'types/Claims';

const initialState: IState = {
	claims: [],
	change: false,
	claimUuids: [],
	claimExcludeUuids: [],
	downloadAll: false,
	pages: 1,
	page: 1,
	search: false,
	totalClaims: 0,
};

export const getClaims = createAsyncThunk(
	'claims/getClaims',
	getClaimsByProviderThunk,
);

export const downloadClaims = createAsyncThunk(
	'claims/downloadClaims',
	downloadClaimsThunk,
);

export const getClaimsNotifications = createAsyncThunk(
	'claims/getClaimsNotifications',
	getClaimsNotificationsThunk,
);

export const getClaimsNotificationsStatuses = createAsyncThunk(
	'claims/getClaimsNotificationsStatuses',
	getClaimsNotificationsStatusesThunk,
);

const claimsSlice = createSlice({
	name: 'claims',
	initialState,
	reducers: {
		setSearchValue: (
			state: any,
			{ payload }: PayloadAction<{ name: keyof IState; value: string }>,
		) => {
			const { name, value } = payload;
			state[name] = value;
		},
		setChangeFalse: state => {
			state.change = false;
		},
		setclaimUuids: (state, { payload }: PayloadAction<string[] | []>) => {
			if (payload.length > 0) {
				state.claimUuids = state.claimUuids
					.concat(payload)
					.filter(
						(value: string, index: number, self: string[]) =>
							self.indexOf(value) === index,
					);
			} else {
				state.claimUuids = [];
			}
		},
		setClaimExcludeIds: (state, { payload }: PayloadAction<string[] | []>) => {
			state.claimExcludeUuids = payload;
		},
		setDownloadAll: (state: IState, { payload }: PayloadAction<boolean>) => {
			state.downloadAll = payload;
		},
		setSelectOne: (state, { payload }: PayloadAction<string>) => {
			if (state.claimUuids.includes(payload)) {
				const list = state.claimUuids.filter((e: string) => e !== payload);
				state.claimUuids = list;
				if (state.downloadAll) {
					state.claimExcludeUuids.push(payload);
				}
			} else {
				state.claimUuids.push(payload);
				state.claimExcludeUuids = state.claimExcludeUuids.filter(
					(id: string) => id !== payload,
				);
			}
		},
		changePage: (state: IState, { payload }: PayloadAction<number>) => {
			state.page = payload;
		},
		setSearch: (state: IState, { payload }: PayloadAction<boolean>) => {
			state.search = payload;
		},
		resetClaims: state => {
			return {
				...initialState,
				totalClaims: state.totalClaims,
			};
		},
	},
	extraReducers: builder => {
		builder
			.addCase(getClaims.fulfilled, (state, { payload }) => {
				state.claims = payload.claims;
				state.change = true;
				state.pages = payload.pages;
			})
			.addCase(getClaims.rejected, state => {
				state.claims = [];
			})
			.addCase(getClaimsNotifications.fulfilled, (state, { payload, meta }) => {
				if (!meta.arg.list && payload) state.totalClaims = payload.totalClaims;

				if (meta.arg.list) {
					state.claims = payload.claims;
					state.pages = payload.pages;
				}
			})
			.addCase(getClaimsNotifications.rejected, state => {
				state.claims = [];
				state.totalClaims = 0;
				state.pages = 0;
			});
	},
});

export const {
	resetClaims,
	setChangeFalse,
	setDownloadAll,
	setSelectOne,
	changePage,
	setSearchValue,
	setSearch,
	setclaimUuids,
	setClaimExcludeIds,
} = claimsSlice.actions;
export default claimsSlice.reducer;
